import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Col, Input, InputGroup, InputGroupText, Row, Table } from "reactstrap"

export default function index(props) {
  const {
    fabricCompanyId,
    fabricCompanyIds,
    fabricId,
    brandAndBunch,
    optionBrandAndbunch,
    fabricIds,
    fabricSeasonId,
    fabricSeasonIds,
    fabricYear,
    fabricYears,
    width,
    rank,
    scale,
    handleInput,
    setScale,
    setWidth,
    setRank,
    setFabricYear, // untuk clear
    setFabricId, // untuk clear
    setFabricSeasonId, // untuk clear
    setBrandAndBunch, // untuk clear
    payload,
  } = props.config

  return (
    <>
      <p className="text-center">MATERIAL</p>
      <Table bordered>
        <tbody>
          <tr>
            <th style={{ minWidth: 115 }}> 生地商社</th>
            <td>
              <SelectBox
                options={fabricCompanyIds}
                value={fabricCompanyId}
                onChange={v => {
                  handleInput({ val: v, type: "fabricCompanyId" })
                  setFabricYear("")
                  setFabricId("")
                  setFabricSeasonId("")
                  setBrandAndBunch("")
                  setScale("")
                  setWidth("")
                  setRank("")
                }}
              />
            </td>
          </tr>
          <tr>
            <th>生地メーカ</th>
            <td>
              <SelectBox
                options={optionBrandAndbunch}
                value={brandAndBunch}
                onChange={v => {
                  handleInput({ val: v, type: "brandAndBunch" })
                  setFabricYear("")
                  setFabricId("")
                  setFabricSeasonId("")
                  setScale("")
                  setWidth("")
                  setRank("")
                }}
              />
            </td>
          </tr>
          <tr>
            <th>年度・シーズン</th>
            <td>
              <Row>
                <Col>
                  <SelectBox
                    options={fabricYears}
                    value={fabricYear}
                    onChange={v => {
                      handleInput({ val: v, type: "fabricYear" })
                      // setFabricId("")
                      setFabricSeasonId("")
                      // setScale("")
                      // setWidth("")
                      // setRank("")
                    }}
                  />
                </Col>
                <Col>
                  <SelectBox
                    options={fabricSeasonIds}
                    value={fabricSeasonId}
                    onChange={v => {
                      handleInput({ val: v, type: "fabricSeasonId" })
                      // setFabricId("")
                      // setScale("")
                      // setWidth("")
                      // setRank("")
                    }}
                  />
                </Col>
              </Row>
            </td>
          </tr>
          <tr>
            <th>Art No.・用尺</th>
            <td>
              <Row>
                <Col>
                  {/* <Input type="text" disabled /> */}
                  <SelectBox
                    options={fabricIds}
                    value={fabricId}
                    onChange={v => handleInput({ val: v, type: "fabricId" })}
                    isDisabled={
                      fabricCompanyId?.value !== "" &&
                      brandAndBunch?.value !== ""
                        ? false
                        : true
                    }
                  />
                </Col>
                <Col>
                  <InputGroup>
                    <Input
                      type="text"
                      disabled={fabricId.value !== "" ? false : true}
                      name="scale"
                      value={scale}
                      onChange={v => {
                        setScale(v.target.value)
                        handleInput({ val: v, type: "scale" })
                      }}
                    />
                    <InputGroupText>M</InputGroupText>
                  </InputGroup>
                </Col>
              </Row>
            </td>
          </tr>
          <tr>
            <th>生地巾・ランク</th>
            <td>
              <Row>
                <Col>
                  <Input type="text" disabled value={width} />
                </Col>
                <Col>
                  <Input type="text" disabled value={rank} />
                </Col>
              </Row>
            </td>
          </tr>
          <tr>
            <th>カラー</th>
            <td>
              <Input
                type="text"
                name="color"
                value={payload.color}
                onChange={e => handleInput({ e, type: "color" })}
              />
            </td>
          </tr>
          <tr>
            <th>表地組成</th>
            <td>
              <Input
                type="text"
                onChange={e =>
                  handleInput({ e, type: "outerMaterialComposition" })
                }
                name="outerMaterialComposition"
                value={payload.outerMaterialComposition}
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  )
}
